import axios from "axios"
import useJwt from '@/auth/jwt/useJwt'
import router from '@/router'

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    maxRedirects: 0,
});

client.interceptors.request.use(
    config => {
        const token = useJwt.getToken();

        if (token) {
            config.headers = {
                'Authorization': `Bearer ${token}`
            }
        }
        return config;
    },
    error => Promise.reject(error)
);

client.interceptors.response.use(
    response => response,
    error => {
        if (error.response)
        {
            if (error.response.status === 403 || error.response.status === 401) {
                useJwt.logout();
                router.push({ name: 'login' });
            }

            console.log("error ----> ", error.response);
        }
        else 
            console.log("error ----> ", error);
        
        // return Promise.reject(error);
        return Promise.resolve(error.response);
    }
);

export default client;